import styled from 'styled-components';

export const Main = styled.div`
   min-width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
  .textarea {
      margin: 35px 0 0;
      /* > div {
         min-width: 316.8px !important;
      } */
   }
   .textInput {
      h4 { width: 145px; }
   }
   > .title {
      position: relative;
      top: calc(25px / 2);
      left: 7.5px;
      display: inline-flex;
      align-items: center;
      background-color: rgb(245, 245, 245);
      border: 1px solid rgb(220, 220, 220);
      padding: 0 7.5px;
      height: 25px;
      border-radius: 5px;
      z-index: 99;
   }
   .inputs {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: rgb(245, 245, 245);
      border: 1px solid rgb(220, 220, 220);
      border-radius: 5px;
      padding: 25px 15px 15px;
      overflow: auto;
      cursor: default;

      .item {
         display: flex;
         font-size: 15px;

         &:not(:last-of-type) { margin-bottom: 10px; }
         > div {
            display: flex;

            span:first-of-type {
               width: 10px;
               height: 10px;
               background-color: red;
               margin-right: 7.5px;
               border-radius: 2px;

               &.red {
                  background-color: red;
                  box-shadow: 0 0 3px red;
               }
               &.green {
                  background-color: #339966;
                  box-shadow: 0 0 3px #339966;
               }
            }
            span:last-of-type {
               width: 147px;
               opacity: 0.85;
            }
         }
         ul li { opacity: 0.85; }
      }
   }
   .pdfToImg {
      margin-top: 10px;
   }
`;